import { IAddress, AddressModel } from "../Address"
import { TenantUserFields } from "../TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { HumanModel } from "./Human";



export class WorkerModel extends HumanModel  {

    constructor(data = null, usertype = null) {
        super(data, usertype);
        
        if(data) {
            this.createModel(data);
        }
    }
}